import React from 'react';
import {connect} from 'react-redux';

import styles from './settings.css';
import Page from '../../components/page/page';
import bindAll from "lodash.bindall";

import {setUser} from '../../reducers/teach';
import {cnPerformance} from '../../api/user';
import PageContentMargin from "../../components/page-content-margin/page-content-margin";

class PromotePage extends React.PureComponent {

    constructor(props) {
        super(props);
        bindAll(this, [
            'getCN',
        ]);
        this.state = {
            CN: {}
        }
    }

    componentDidMount() {
        this.getCN();
    }

    //获取渠道号
    getCN() {
        cnPerformance({}, {quiet: !!this.props.user.id}).then(res => {
            this.setState({
                CN: res
            })
        });
    }

    render() {
        const {CN} = this.state;
        let Num = 0
        if(CN.month&&CN.month.length > 0){
            CN.month.forEach(ele => {
                Num += ele.num
            });
        }
        return (
            <Page isModal={true} title="推广收入">
                <PageContentMargin>
                    <div className={styles.promoteBox}>
                        <div className={styles.total}>
                            <span>累计推广用户数：{Num}人</span>
                            <span>累计收入：{Num * 100}元</span>
                        </div>
                        <div className={styles.table}>
                            <div className={styles.tableHeader}>
                                <span>月份</span>
                                <span>推广用户数(人)</span>
                                <span>收入(元)</span>
                            </div>
                            <div className={styles.tableContent}>
                                {
                                    CN.month && CN.month.length > 0 ? (
                                        CN.month.map(item => (
                                            <div key={item.month} className={styles.tableItem}>
                                                <span>{item.month}</span>
                                                <span>{item.num}</span>
                                                <span>{item.num * 100}</span>
                                            </div>
                                        ))
                                    ) : (
                                        <div className={styles.tableItem}>
                                            <span>暂无数据</span>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </PageContentMargin>
            </Page>
        );
    }
}


const mapStateToProps = state => ({
    user: state.teach.user
});


const mapDispatchToProps = dispatch => ({
    setUser: res => dispatch(setUser(res))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PromotePage);
